import React from "react";
import "../css/my style.css";



export default function ButtonHome() {
    return (
        <button className="previous" style={{display: "flex", flexDirection: "row"}}>&laquo;Back to Home</button>
    )
}